import styled from "styled-components";

export const CreateAccountSc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  padding-top: 20px;
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 25px;
  margin-top: 10px;
  .form-container {
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    padding: 0.4em 2em;
    display: flex;
    justify-content: center;
    width: auto;
    background: rgb(111, 45, 137);
    color: white;
    margin: 5px;
  }

  .form-field-container {
    display: flex;
    flex-direction: column;

    gap: 0.1em;
  }
  .create-user-form {
    display: flex;
    flex-direction: column;
    gap: 0.9em;
  }
  .form-input {
    outline: 0;
    padding: 0.2em 0.4em;
    width: 100%;
  }
  .btn-container {
    display: flex;
    justify-content: center;
    padding: 0.2em;
  }
  .btn-container button {
    padding: 0.1em 1em;
    border-radius: 10px;
  }
  .org-user-role {
  }
  .org-roles {
    outline: 0;
    padding: 0.2em 0.4em;
    width: 100%;
    border-radius: 3px;
  }
`;
